// Customer account side of the web app — same endpoints the mobile app's Relay, bell, wishlist, tickets,
// wallet, Plan-my-day and settings screens use.
import { api, qs } from "@/lib/api";

export const relayApi = {
  list: () => api("/conversations"),
  start: (listing_id, booking_id) => api("/conversations", { method: "POST", body: booking_id ? { listing_id, booking_id } : { listing_id } }),
  get: (id) => api(`/conversations/${id}`),
  messages: (id) => api(`/conversations/${id}/messages`),
  poll: (id) => api(`/conversations/${id}/poll`),
  send: (id, text) => api(`/conversations/${id}/messages`, { method: "POST", body: { type: "text", text } }),
  escalate: (id) => api(`/conversations/${id}/escalate`, { method: "POST" }),
  typing: (id) => api(`/conversations/${id}/typing`, { method: "POST", body: { typing: true } }).catch(() => null),
};

export const notificationsApi = {
  list: () => api("/notifications"),
  readAll: () => api("/notifications/read-all", { method: "POST" }),
  read: (id) => api(`/notifications/${id}/read`, { method: "POST" }),
  prefs: () => api("/notifications/preferences"),
  setPrefs: (body) => api("/notifications/preferences", { method: "PATCH", body }),
};

export const ticketsApi = {
  mine: (scope = "upcoming") => api(`/events/tickets/mine?${qs({ scope })}`),
  get: (id) => api(`/events/tickets/${id}`),
};

export const walletApi = {
  get: () => api("/wallet"),
  topup: (amount, return_base) => api("/wallet/topup", { method: "POST", body: { amount, return_base } }),
  redeemGiftCard: (code) => api("/wallet/gift-cards/redeem", { method: "POST", body: { code } }),
};

export const planDayApi = {
  get: (params) => api(`/travel/plan-day?${qs(params)}`),
};

export const addressesApi = {
  list: () => api("/addresses"),
  create: (body) => api("/addresses", { method: "POST", body }),
  remove: (id) => api(`/addresses/${id}`, { method: "DELETE" }),
  setDefault: (id) => api(`/addresses/${id}/default`, { method: "POST" }),
};

export const sessionsApi = {
  list: () => api("/auth/sessions"),
  revoke: (id) => api(`/auth/sessions/${id}`, { method: "DELETE" }),
  revokeAll: () => api("/auth/sessions/revoke-all", { method: "POST" }),
};

export const NOTIF_CATEGORIES = [
  { key: "booking", label: "Booking confirmations", sub: "When a booking or order is confirmed" },
  { key: "reminders", label: "Reminders", sub: "Upcoming bookings and reminders you set" },
  { key: "pickup", label: "Food pickups", sub: "When your order is ready to collect" },
  { key: "casting", label: "Casting updates", sub: "Updates on your applications" },
  { key: "promotions", label: "Promotions", sub: "Offers and news from Fable" },
  { key: "ads", label: "Ads & sponsored messages", sub: "Sponsored messages from providers. Off by default." },
  { key: "posts", label: "New posts", sub: "Photos and videos from providers you follow" },
  { key: "system", label: "System", sub: "Account and security alerts" },
];

export function relTime(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)}d`;
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  } catch {
    return "";
  }
}

/** Where a notification should take you on the web (mirrors the app's routing order). */
export function notificationTarget(n) {
  const u = n.action_url || "";
  if (u) {
    if (/^https?:/i.test(u)) return u;
    if (u.startsWith("/booking-detail/")) return `/bookings`;
    if (u.startsWith("/pulse/")) return `/stage/post/${u.split("/")[2]}`;
    if (u.startsWith("/creators/")) return `/@${u.split("/")[2]}`;
    if (u.startsWith("/listing/")) return u;
    if (u.startsWith("/events/")) return "/tickets";
    if (u.startsWith("/messages/")) return u;
    return u;
  }
  if (n.booking_id) return "/bookings";
  if (n.listing_id) return `/listing/${n.listing_id}`;
  return null;
}
